import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Error, PageLayout } from 'core/components';
import { StatusCode } from 'core/constants';
import { Loader } from 'core/elements';
import { ElementTemplateDetails } from 'elements/components';
import { useGetElementTemplate } from 'elements/hooks';

export const ElementTemplateDetailsPage = () => {
  const { id } = useParams();

  const { t } = useTranslation();

  const { record, isLoading, isError } = useGetElementTemplate({ filters: { id: Number(id) } });

  return (
    <PageLayout
      title={
        record?.customIdentifier
          ? t('titleElementTemplateDetailsWithName', { name: record.customIdentifier })
          : t('titleElementTemplateDetails')
      }
    >
      {isLoading && <Loader />}

      {isError && <Error statusCode={StatusCode.NOT_FOUND} />}

      {record && <ElementTemplateDetails elementTemplate={record} />}
    </PageLayout>
  );
};
